/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import {
  Loader, Checkbox, Modal, Popup, Label, Icon, List, Segment, Dimmer
} from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import $ from 'jquery';
import { withTranslation } from 'react-i18next';
import SettingContentsHeader from './SettingContentsHeader';
import ChangeStatusProject from '../Modal/ChangeStatusProject';
import DeleteProjectModal from '../Modal/DeleteProjectModal';
import NewProjectModal from '../Modal/NewProjectModal';
import EditProjectModal from '../Modal/EditProjectModal';
import api from '../../api';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';
import WithRouter from '../Extensions/WithRouter';

class ProjectSetting extends Component {
  constructor(props) {
    super(props);
    this.projectSettingBody = React.createRef();
    this.state = {
      isOpen: false,
      isOpenMCS: false,
      isOpenMDP: false,
      isOpenMCP: false,
      isOpenMEP: false,
      isPageLoading: false,
      pageSize: 10,
      currentPage: 1,
      projectList: [],
      checkValue: [],
      sortColumn: '1',
      isSort: false,
      error: null,
      isLoading: false,
      isNextLoading: false,
      itemsChecked: false,
      versionList: [],
      uploadedList: [],
      memberList: {
        group_list: [],
        member_list: [],
      },
      assignedPolicies: {
        company_policy_list: [],
        project_policy_list: [],
      },
      userDefinedList: {
        company_user_defined_list: [],
        project_user_defined_list: [],
      },
      filter: [],
      selectedList: [],
      selectedProjectId: '',
      popupStatus: {
        versionPopup: false,
        filePopup: false,
        memberPopup: false,
        policyPopup: false,
        userDefinedPopup: false,
      },
      activeIndex: '',
    };

    this.handleOnScroll = this.handleOnScroll.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleMCSOpen = this.handleMCSOpen.bind(this);
    this.handleMCSClose = this.handleMCSClose.bind(this);
    this.handleMDPOpen = this.handleMDPOpen.bind(this);
    this.handleMDPClose = this.handleMDPClose.bind(this);
    this.handleMCPOpen = this.handleMCPOpen.bind(this);
    this.handleMCPClose = this.handleMCPClose.bind(this);
    this.handleMEPOpen = this.handleMEPOpen.bind(this);
    this.handleMEPClose = this.handleMEPClose.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCompleteCallback = this.handleCompleteCallback.bind(this);
    this.handleDeleteCallback = this.handleDeleteCallback.bind(this);
    this.onChangeSorting = this.onChangeSorting.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.clearValue = this.clearValue.bind(this);
    this.clearAllValue = this.clearAllValue.bind(this);
    this.handleFilterData = this.handleFilterData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleNewProjectCallback = this.handleNewProjectCallback.bind(this);
    this.handleEditProjectCallback = this.handleEditProjectCallback.bind(this);
    this.handleProjectCheckAll = this.handleProjectCheckAll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleOnScroll);
    this.onUpdateLoading();
    const $contentsHeader = $('.contents_header');
    const $tableHeader = $('.setting_table_header');
    const $window = $(window);

    $window.on('scroll.contents_header', () => {
      if ($window.scrollTop() > 0) {
        $contentsHeader.addClass('fixed');
        $tableHeader.addClass('fixed');
      } else {
        $contentsHeader.removeClass('fixed');
        $tableHeader.removeClass('fixed');
      }
    });

    $(document).on(
      'mouseover',
      '.setting_project_content .setting_project_table .project_name .content_wrapper',
      function () {
        const $this = $(this);
        if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
          $this.attr('title', $this.text());
        }
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      isPageLoading,
      isOpenMCP,
      isOpenMDP,
      isOpenMEP,
      isOpen,
      isOpenMCS
    } = this.state;
    if (prevState.isOpenMCP !== isOpenMCP || prevState.isOpenMDP !== isOpenMDP || prevState.isOpenMEP !== isOpenMEP || prevState.isOpen !== isOpen || prevState.isOpenMCS !== isOpenMCS) {
      this.handleClose();
    }

    if (prevState.isPageLoading !== isPageLoading && isPageLoading) {
      this.getProjectList();
      this.setState({
        isPageLoading: false,
        memberList: {
          group_list: [],
          member_list: [],
        },
        popupStatus: {
          versionPopup: false,
          filePopup: false,
          memberPopup: false,
          policyPopup: false,
          userDefinedPopup: false,
        },
        activeIndex: '',
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleOnScroll);
  }

  handleCheckChange(e, { value }) {
    const { checkValue, projectList } = this.state;
    let newState;
    if (checkValue.indexOf(value) > -1) {
      newState = checkValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValue, value];
    }

    if (newState.length !== 0 && newState.length !== projectList.length) {
      this.setState({
        checkValue: newState,
        itemsChecked: false,
      });
    } else {
      this.setState({
        checkValue: newState,
      });
    }
  }

  handleProjectCheckAll() {
    const { itemsChecked, projectList } = this.state;
    const newState = [];

    if (itemsChecked) {
      this.setState({
        itemsChecked: false,
        checkValue: [],
      });
    } else {
      const num = projectList.length;
      let i = 0;
      for (i; i < num; i++) {
        newState.push(projectList[i].pid);
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        itemsChecked: true,
        checkValue: unique,
      });
    }
  }

  handleOnScroll() {
    const {
      getProjectList,
      state: { error, isNextLoading, hasMoreProjectList },
    } = this;
    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const { clientHeight } = document.documentElement;

    if (error || isNextLoading || !hasMoreProjectList) {
      return;
    }

    if (scrollTop + clientHeight >= scrollHeight) {
      getProjectList(this.state.currentPage + 1);
    }
  }

  handleMDPOpen() {
    const { checkValue } = this.state;

    if (checkValue.length === 0) {
      this.setState({
        isOpen: true,
      });
    } else {
      this.setState({
        isOpenMDP: true,
      });
    }
  }

  handleMDPClose() {
    this.setState(
      {
        projectList: [],
        isOpenMDP: false,
      },
      () => {
        this.getProjectList();
      }
    );
  }

  handleMCSOpen() {
    const { checkValue, projectList } = this.state;

    const selectedArr = projectList.filter((item) => {
      return checkValue.indexOf(item.pid) > -1;
    });

    if (checkValue.length === 0) {
      this.setState({
        isOpen: true,
      });
      return false;
    }

    this.setState({
      isOpenMCS: true,
      selectedList: selectedArr,
    });
  }

  handleMCSClose() {
    this.setState({
      isOpenMCS: false,
    });
  }

  handleMCPOpen() {
    this.setState({
      isOpenMCP: true,
    });
  }

  handleMCPClose() {
    this.setState({
      isOpenMCP: false,
    });
  }

  handleMEPOpen(projectId) {
    this.setState({
      isOpenMEP: true,
      selectedProjectId: projectId,
    });
  }

  handleMEPClose() {
    this.setState({
      isOpenMEP: false,
    });
  }

  handleChange(value) {
    this.setState(
      {
        searchKeyword: value,
        projectList: [],
      },
      () => {
        this.getProjectList();
      }
    );
  }

  handleFilterData(value) {
    this.setState(
      {
        projectList: [],
        filter: value.filter,
      },
      () => {
        this.getProjectList();
      }
    );
  }

  handleCompleteCallback(statusCode) {
    if (statusCode) {
      this.setState(
        {
          itemsChecked: false,
          projectList: [],
          checkValue: [],
        },
        () => {
          this.getProjectList();
        }
      );
    } else {
      console.log('failed to save');
    }
  }

  handleDeleteCallback() {
    this.setState(
      {
        itemsChecked: false,
        projectList: [],
        checkValue: [],
        isOpenMDP: false,
      },
      () => {
        this.getProjectList();
      }
    );
  }

  handleNewProjectCallback() {
    this.setState(
      {
        itemsChecked: false,
        projectList: [],
        checkValue: [],
      },
      () => {
        this.getProjectList();
      }
    );
  }

  handleEditProjectCallback() {
    this.setState(
      {
        itemsChecked: false,
        projectList: [],
        checkValue: [],
      },
      () => {
        this.getProjectList();
      }
    );
  }

  handleClose() {
    const status = {
      versionPopup: false,
      filePopup: false,
      memberPopup: false,
      policyPopup: false,
      userDefinedPopup: false,
    };
    this.setState({
      popupStatus: status,
      activeIndex: '',
    });
  }

  onUpdateLoading() {
    this.setState({
      isPageLoading: true,
    });
  }

  onChangeSorting = (e) => {
    const { isSort } = this.state;
    if (e.currentTarget.dataset.id !== this.state.sortColumn) {
      this.setState(
        {
          sortColumn: e.currentTarget.dataset.id,
          isSort: false,
          projectList: [],
          activeIndex: [],
        },
        () => {
          this.getProjectList();
        }
      );
    } else {
      this.setState(
        {
          sortColumn: e.currentTarget.dataset.id,
          isSort: !isSort,
          projectList: [],
          activeIndex: [],
        },
        () => {
          this.getProjectList();
        }
      );
    }
  };

  getProjectList = (pageNo, limit) => {
    const {
      pageSize, isSort, sortColumn, filter, projectList, searchKeyword
    } = this.state;
    const { t } = this.props;

    const filterData = filter.length ? filter.join(',') : '';

    const sortOrderMappings = {
      1: isSort ? 'project' : 'project_r',
      2: isSort ? 'version_r' : 'version',
      3: isSort ? 'uploaded_count_r' : 'uploaded_count',
      4: isSort ? 'scanned_size_r' : 'scanned_size',
      5: isSort ? 'member_r' : 'member',
      6: isSort ? 'owner' : 'owner_r',
      7: isSort ? 'modified_r' : 'modified',
      8: isSort ? 'uploaded_r' : 'uploaded',
      9: isSort ? 'status' : 'status_r',
      10: isSort ? 'policy_r' : 'policy',
      11: isSort ? 'user_defined_r' : 'user_defined',
    };

    const orderText = sortOrderMappings[sortColumn] || 'modified';

    const page = pageNo || 1;
    const perPage = limit || pageSize;

    this.setState({
      ...(page === 1 ? { isLoading: true } : { isNextLoading: true }),
    });

    api
      .getSProjectList(
        {
          search: searchKeyword,
          page,
          limit: perPage,
          order: orderText,
          filter: filterData,
        }
      )
      .then((response) => {
        if (projectList.length !== 0 && response.pagination.current === 1) return;

        const nextProjectList = response.response.map((item) => {
          return {
            pid: item.id,
            name: item.name,
            versionCount: item.version_count,
            uploadedCount: item.uploaded_count,
            scannedSize: item.scanned_size,
            policyCount: item.policy_count,
            memberCount: item.member_count,
            owner: item.owner,
            lastModified: item.last_modified,
            lastUploaded: item.last_uploaded,
            status: item.status,
            userDefinedCount: item.user_defined_count,
          };
        });
        this.setState({
          currentPage: response.pagination.current,
          pageSize: response.pagination.per_page,
          currentCount: response.pagination.count,
          hasMoreProjectList: response.pagination.next !== null,
          isLoading: false,
          isNextLoading: false,
          projectList: page === 1 ? nextProjectList : [...projectList, ...nextProjectList],
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
          isLoading: false,
          isNextLoading: false,
        });
      });
  };

  getSProjectVersionDetail = (projectId) => {
    const { t } = this.props;
    const status = {
      versionPopup: true,
      filePopup: false,
      memberPopup: false,
      policyPopup: false,
      userDefinedPopup: false,
    };
    api
      .getSProjectVersionDetail(projectId)
      .then((response) => {
        const data = response.response;
        this.setState({
          popupStatus: status,
          activeIndex: projectId,
          versionList: data.version_list,
          uploadedList: [],
          memberList: {
            group_list: [],
            member_list: [],
          },
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
          isLoading: false,
        });
      });
  };

  getSProjectFileDetail = (projectId) => {
    const { t } = this.props;
    const status = {
      versionPopup: false,
      filePopup: true,
      memberPopup: false,
      policyPopup: false,
      userDefinedPopup: false,
    };
    api
      .getSProjectFileDetail(projectId)
      .then((response) => {
        const data = response.response;
        this.setState({
          popupStatus: status,
          activeIndex: projectId,
          uploadedList: data.uploaded_list,
          versionList: [],
          memberList: {
            group_list: [],
            member_list: [],
          },
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
          isLoading: false,
        });
      });
  };

  getSProjectMemberDetail = (projectId) => {
    const { t } = this.props;
    const status = {
      versionPopup: false,
      filePopup: false,
      memberPopup: true,
      policyPopup: false,
      userDefinedPopup: false,
    };
    api
      .getSProjectMemberDetail(projectId)
      .then((response) => {
        const data = response.response;
        this.setState({
          popupStatus: status,
          activeIndex: projectId,
          memberList: data,
          versionList: [],
          uploadedList: [],
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
          isLoading: false,
        });
      });
  };

  getsProjectPolicyDetail = (projectId) => {
    const { t } = this.props;
    const status = {
      policyPopup: true,
      versionPopup: false,
      filePopup: false,
      memberPopup: false,
      userDefinedPopup: false,
    };
    api
      .getsProjectPolicyDetail(projectId)
      .then((response) => {
        const data = response.response;
        this.setState({
          popupStatus: status,
          activeIndex: projectId,
          assignedPolicies: data,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
          isLoading: false,
        });
      });
  };

  fetchUserDefinedProjectSettings = (projectId) => {
    const { t } = this.props;
    const status = {
      policyPopup: false,
      versionPopup: false,
      filePopup: false,
      memberPopup: false,
      userDefinedPopup: true,
    };
    api
      .fetchUserDefinedProjectSettings(projectId)
      .then((response) => {
        const data = response.response;
        this.setState({
          popupStatus: status,
          activeIndex: projectId,
          userDefinedList: data,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
          isLoading: false,
        });
      });
  };

  clearValue = (tagValue) => {
    const { filter } = this.state;
    let newState;
    if (filter.indexOf(tagValue) > -1) {
      newState = filter.filter((el) => {
        return el !== tagValue;
      });
    } else {
      newState = [];
    }
    this.setState(
      {
        projectList: [],
        filter: newState,
      },
      () => {
        this.getProjectList();
      }
    );
  };

  clearAllValue = () => {
    this.setState(
      {
        projectList: [],
        filter: [],
      },
      () => {
        this.getProjectList();
      }
    );
  };

  clearSearch() {
    this.setState(
      {
        searchKeyword: '',
        projectList: [],
      },
      () => {
        this.getProjectList();
      }
    );
  }

  closeErrorModal() {
    this.setState({
      isOpen: false,
    });
  }

  renderValue() {
    const { filter } = this.state;
    const { t } = this.props;

    return (
      <div>
        {filter.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('settings.list.status')}</strong>
            </span>
            {filter.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item === 'active' && t('modal.title.active')}
                  {item === 'inactive' && t('modal.title.inactive')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filter.length !== 0 ? (
          <div
            className="clear_all"
            onClick={() => {
              return this.clearAllValue();
            }}
            onKeyUp={() => {
              return this.clearAllValue();
            }}
          >
            {t('project.menu.clear_all_filters')}
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    const {
      projectList,
      checkValue,
      error,
      isLoading,
      isNextLoading,
      currentCount,
      sortColumn,
      isSort,
      filter,
      activeIndex,
      itemsChecked,
      popupStatus,
      versionList,
      assignedPolicies,
      memberList,
      userDefinedList,
    } = this.state;
    const { location, state, t } = this.props;
    const pathname = location.pathname ? location.pathname : location;

    return (
      <div className="setting_project" ref={this.projectSettingBody}>
        <SettingContentsHeader
          projectCount={currentCount}
          changeStatus={this.handleMCSOpen}
          deleteProject={this.handleMDPOpen}
          addNewProject={this.handleMCPOpen}
          onChangeSearch={this.handleChange}
          onSubmit={this.handleFilterData}
          clearSearch={this.clearSearch}
          filter={filter}
          location={pathname}
          state={state}
          translate={t}
        />
        <div className="setting_project_content">
          {filter.length !== 0 ? <div className="tag_list">{this.renderValue()}</div> : ''}
          <div className="setting_table_header">
            <div className="setting_table_header_inner">
              <table className="setting_project_table table_header">
                <colgroup>
                  <col style={{ width: '36px' }} />
                  <col style={{ width: '160px' }} />
                  <col style={{ width: '8%' }} />
                  <col style={{ width: '8%' }} />
                  <col style={{ width: '8%' }} />
                  <col style={{ width: '8%' }} />
                  <col style={{ width: '8%' }} />
                  <col style={{ width: '8%' }} />
                  <col style={{ width: '8%' }} />
                  <col style={{ width: '11%' }} />
                  <col style={{ width: '11%' }} />
                  <col style={{ width: '5%' }} />
                  <col style={{ width: '' }} />
                </colgroup>
                <thead>
                  <tr>
                    <th>
                      <Checkbox checked={itemsChecked} onChange={this.handleProjectCheckAll} />
                    </th>
                    <th className="project_name">
                      <a className="sorting_button" data-id="1" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                        {t('list.title.project_name')}
                        {isSort && sortColumn === '1' ? <img src={upIcon} alt="" /> : ''}
                        {!isSort && sortColumn === '1' ? <img src={downIcon} alt="" /> : ''}
                      </a>
                    </th>
                    <th>
                      <a className="sorting_button" data-id="2" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                        {t('list.title.project_version')}
                        {isSort && sortColumn === '2' ? <img src={upIcon} alt="" /> : ''}
                        {!isSort && sortColumn === '2' ? <img src={downIcon} alt="" /> : ''}
                      </a>
                    </th>
                    <th>
                      <a className="sorting_button" data-id="3" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                        {t('list.title.uploaded_files')}
                        {isSort && sortColumn === '3' ? <img src={upIcon} alt="" /> : ''}
                        {!isSort && sortColumn === '3' ? <img src={downIcon} alt="" /> : ''}
                      </a>
                    </th>
                    <th>
                      <a className="sorting_button" data-id="4" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                        {t('list.title.scanned_size')}
                        {isSort && sortColumn === '4' ? <img src={upIcon} alt="" /> : ''}
                        {!isSort && sortColumn === '4' ? <img src={downIcon} alt="" /> : ''}
                      </a>
                    </th>
                    <th>
                      <a className="sorting_button" data-id="10" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                        {t('settings.list.applied_policy')}
                        {isSort && sortColumn === '10' ? <img src={upIcon} alt="" /> : ''}
                        {!isSort && sortColumn === '10' ? <img src={downIcon} alt="" /> : ''}
                      </a>
                    </th>
                    <th>
                      <a className="sorting_button" data-id="11" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                        {t('contents_header.menu.user_defined')}
                        {isSort && sortColumn === '11' ? <img src={upIcon} alt="" /> : ''}
                        {!isSort && sortColumn === '11' ? <img src={downIcon} alt="" /> : ''}
                      </a>
                    </th>
                    <th>
                      <a className="sorting_button" data-id="5" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                        {t('modal.title.project_member')}
                        {isSort && sortColumn === '5' ? <img src={upIcon} alt="" /> : ''}
                        {!isSort && sortColumn === '5' ? <img src={downIcon} alt="" /> : ''}
                      </a>
                    </th>
                    <th className="owner">
                      <a className="sorting_button" data-id="6" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                        <span>{t('modal.title.project_owner')}</span>
                        {isSort && sortColumn === '6' ? <img src={upIcon} alt="" /> : ''}
                        {!isSort && sortColumn === '6' ? <img src={downIcon} alt="" /> : ''}
                      </a>
                    </th>
                    <th className="created">
                      <a className="sorting_button" data-id="7" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                        <span>{t('settings.list.last_modified')}</span>
                        {isSort && sortColumn === '7' ? <img src={upIcon} alt="" /> : ''}
                        {!isSort && sortColumn === '7' ? <img src={downIcon} alt="" /> : ''}
                      </a>
                    </th>
                    <th className="created">
                      <a className="sorting_button" data-id="8" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                        <span>{t('list.title.last_uploaded')}</span>
                        {isSort && sortColumn === '8' ? <img src={upIcon} alt="" /> : ''}
                        {!isSort && sortColumn === '8' ? <img src={downIcon} alt="" /> : ''}
                      </a>
                    </th>
                    <th>
                      <a className="sorting_button" data-id="9" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                        {t('list.title.status')}
                        {isSort && sortColumn === '9' ? <img src={upIcon} alt="" /> : ''}
                        {!isSort && sortColumn === '9' ? <img src={downIcon} alt="" /> : ''}
                      </a>
                    </th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          {
            !isLoading ? (
              <div>
                {projectList.length !== 0
                  ? projectList.map((list) => {
                    return (
                      <div className="setting_project_table_wrap" key={uuidv4()}>
                        <table className="setting_project_table">
                          <colgroup>
                            <col style={{ width: '36px' }} />
                            <col style={{ width: '160px' }} />
                            <col style={{ width: '8%' }} />
                            <col style={{ width: '8%' }} />
                            <col style={{ width: '8%' }} />
                            <col style={{ width: '8%' }} />
                            <col style={{ width: '8%' }} />
                            <col style={{ width: '8%' }} />
                            <col style={{ width: '8%' }} />
                            <col style={{ width: '11%' }} />
                            <col style={{ width: '11%' }} />
                            <col style={{ width: '5%' }} />
                            <col style={{ width: '' }} />
                          </colgroup>
                          <tbody>
                            <tr>
                              <td>
                                <div className="content_wrapper">
                                  <Checkbox
                                    value={list.pid}
                                    checked={checkValue.indexOf(list.pid) > -1}
                                    onChange={this.handleCheckChange}
                                  />
                                </div>
                              </td>
                              <td className="project_name">
                                <div className="content_wrapper">{list.name}</div>
                              </td>
                              <td>
                                <div className="content_wrapper pop">
                                  {list.versionCount === 0 ? (
                                    <span className="number">{list.versionCount}</span>
                                  ) : (
                                    <Popup
                                      trigger={(
                                        <span className="number" style={{ cursor: 'pointer' }}>
                                          {list.versionCount}
                                        </span>
                                      )}
                                      on="click"
                                      hideOnScroll
                                      position="bottom left"
                                      style={{ marginLeft: '-17px' }}
                                      open={
                                        popupStatus.versionPopup && activeIndex === list.pid
                                      }
                                      onOpen={() => {
                                        return this.getSProjectVersionDetail(list.pid);
                                      }}
                                      onClose={this.handleClose}
                                    >
                                      <List>
                                        {versionList.map((item) => {
                                          return (
                                            <List.Item key={uuidv4()}>
                                              <List.Icon name="code branch" />
                                              <List.Content>
                                                {item}
                                              </List.Content>
                                            </List.Item>
                                          );
                                        })}
                                      </List>
                                    </Popup>
                                  )}
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper pop">
                                  {list.uploadedCount === 0 ? (
                                    <span className="number">{list.uploadedCount}</span>
                                  ) : (
                                    <Popup
                                      trigger={(
                                        <span className="number" style={{ cursor: 'pointer' }}>
                                          {list.uploadedCount}
                                        </span>
                                      )}
                                      on="click"
                                      hideOnScroll
                                      style={{ marginLeft: '-17px' }}
                                      position="bottom left"
                                      open={
                                        this.state.popupStatus.filePopup && activeIndex === list.pid
                                      }
                                      onOpen={() => {
                                        return this.getSProjectFileDetail(list.pid);
                                      }}
                                      onClose={this.handleClose}
                                    >
                                      <List>
                                        {this.state.uploadedList.map((item) => {
                                          return (
                                            <List.Item key={uuidv4()}>
                                              <List.Icon name="file outline" />
                                              <List.Content>{item}</List.Content>
                                            </List.Item>
                                          );
                                        })}
                                      </List>
                                    </Popup>
                                  )}
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper">{list.scannedSize}</div>
                              </td>
                              <td>
                                <div className="content_wrapper">
                                  {list.policyCount === 0 ? (
                                    <span className="number">{list.policyCount}</span>
                                  ) : (
                                    <Popup
                                      trigger={(
                                        <span
                                          style={{ cursor: 'pointer' }}
                                          onClick={() => {
                                            return this.getsProjectPolicyDetail(list.pid);
                                          }}
                                          onKeyUp={() => {
                                            return this.getsProjectPolicyDetail(list.pid);
                                          }}
                                        >
                                          {list.policyCount}
                                        </span>
                                      )}
                                      on="click"
                                      hideOnScroll
                                      style={{ marginLeft: '-17px' }}
                                      position="bottom left"
                                      open={
                                        popupStatus.policyPopup && activeIndex === list.pid
                                      }
                                      onClose={this.handleClose}
                                    >
                                      <List>
                                        {
                                          assignedPolicies.company_policy_list.length !== 0 ? (
                                            <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                                              <List.Header style={{ margin: '0 0 5px 0' }}>
                                                {t('settings.list.company_policy')}
                                                (
                                                {assignedPolicies.company_policy_list.length}
                                                )
                                              </List.Header>
                                              <List.List>
                                                {
                                                  assignedPolicies.company_policy_list.map((company) => {
                                                    return (
                                                      <List.Item key={uuidv4()}>
                                                        <List.Icon name="object group" />
                                                        <List.Content>{company}</List.Content>
                                                      </List.Item>
                                                    );
                                                  })
                                                }
                                              </List.List>
                                            </List.Item>
                                          ) : null
                                        }
                                        {
                                          assignedPolicies.project_policy_list.length !== 0 ? (
                                            <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                                              <List.Header style={{ margin: '0 0 5px 0' }}>
                                                {t('settings.list.project_policy')}
                                                (
                                                {assignedPolicies.project_policy_list.length}
                                                )
                                              </List.Header>
                                              <List.List>
                                                {
                                                  assignedPolicies.project_policy_list.map((project) => {
                                                    return (
                                                      <List.Item key={uuidv4()}>
                                                        <List.Icon name="object group" />
                                                        <List.Content>{project}</List.Content>
                                                      </List.Item>
                                                    );
                                                  })
                                                }
                                              </List.List>
                                            </List.Item>
                                          ) : null
                                        }
                                      </List>
                                    </Popup>
                                  )}
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper">
                                  {list.userDefinedCount === 0 ? (
                                    <span className="number">{list.userDefinedCount}</span>
                                  ) : (
                                    <Popup
                                      trigger={(
                                        <span
                                          style={{ cursor: 'pointer' }}
                                          onClick={() => {
                                            return this.fetchUserDefinedProjectSettings(list.pid);
                                          }}
                                          onKeyUp={() => {
                                            return this.fetchUserDefinedProjectSettings(list.pid);
                                          }}
                                        >
                                          {list.userDefinedCount}
                                        </span>
                                      )}
                                      on="click"
                                      hideOnScroll
                                      style={{ marginLeft: '-17px' }}
                                      position="bottom left"
                                      open={
                                        popupStatus.userDefinedPopup && activeIndex === list.pid
                                      }
                                      onClose={this.handleClose}
                                    >
                                      <List>
                                        {
                                          userDefinedList.company_user_defined_list.length !== 0 ? (
                                            <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                                              <List.Header style={{ margin: '0 0 5px 0' }}>
                                                {t('settings.list.company_user_defined_list')}
                                                (
                                                {userDefinedList.company_user_defined_list.length}
                                                )
                                              </List.Header>
                                              <List.List>
                                                {
                                                  userDefinedList.company_user_defined_list.map((company) => {
                                                    return (
                                                      <List.Item key={uuidv4()}>
                                                        <List.Icon name="file outline" />
                                                        <List.Content>{company}</List.Content>
                                                      </List.Item>
                                                    );
                                                  })
                                                }
                                              </List.List>
                                            </List.Item>
                                          ) : null
                                        }
                                        {
                                          userDefinedList.project_user_defined_list.length !== 0 ? (
                                            <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                                              <List.Header style={{ margin: '0 0 5px 0' }}>
                                                {t('settings.list.project_user_defined_list')}
                                                (
                                                {userDefinedList.project_user_defined_list.length}
                                                )
                                              </List.Header>
                                              <List.List>
                                                {
                                                  userDefinedList.project_user_defined_list.map((project) => {
                                                    return (
                                                      <List.Item key={uuidv4()}>
                                                        <List.Icon name="file outline" />
                                                        <List.Content>{project}</List.Content>
                                                      </List.Item>
                                                    );
                                                  })
                                                }
                                              </List.List>
                                            </List.Item>
                                          ) : null
                                        }
                                      </List>
                                    </Popup>
                                  )}
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper pop">
                                  {list.memberCount === 0 ? (
                                    <span className="number">{list.memberCount}</span>
                                  ) : (
                                    <Popup
                                      trigger={(
                                        <span className="number" style={{ cursor: 'pointer' }}>
                                          {list.memberCount}
                                        </span>
                                      )}
                                      on="click"
                                      style={{ marginLeft: '-17px' }}
                                      hideOnScroll
                                      position="bottom left"
                                      open={
                                        popupStatus.memberPopup && activeIndex === list.pid
                                      }
                                      onOpen={() => {
                                        return this.getSProjectMemberDetail(list.pid);
                                      }}
                                      onClose={this.handleClose}
                                    >
                                      <List>
                                        {
                                          memberList.group_list.length !== 0 ? (
                                            <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                                              <List.Header style={{ margin: '0 0 5px 0' }}>
                                                {t('settings.list.group')}
                                                (
                                                {this.state.memberList.group_list.length}
                                                )
                                              </List.Header>
                                              <List.List>
                                                {
                                                  memberList.group_list.map((group) => {
                                                    return (
                                                      <List.Item key={uuidv4()}>
                                                        <List.Icon name="group" />
                                                        <List.Content>{group}</List.Content>
                                                      </List.Item>
                                                    );
                                                  })
                                                }
                                              </List.List>
                                            </List.Item>
                                          ) : null
                                        }
                                        {
                                          memberList.member_list.length !== 0 ? (
                                            <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                                              <List.Header style={{ margin: '0 0 5px 0' }}>
                                                {t('settings.list.user')}
                                                (
                                                {memberList.member_list.length}
                                                )
                                              </List.Header>
                                              <List.List>
                                                {
                                                  memberList.member_list.map((member) => {
                                                    return (
                                                      <List.Item key={uuidv4()}>
                                                        <List.Icon name="user" />
                                                        <List.Content>{member}</List.Content>
                                                      </List.Item>
                                                    );
                                                  })
                                                }
                                              </List.List>
                                            </List.Item>
                                          ) : null
                                        }
                                      </List>
                                    </Popup>
                                  )}
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper owner">{list.owner}</div>
                              </td>
                              <td>
                                <div className="content_wrapper created">
                                  <span>{list.lastModified}</span>
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper created">
                                  <span>{list.lastUploaded}</span>
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper owner">{list.status}</div>
                              </td>
                              <td>
                                <div className="content_wrapper">
                                  <a
                                    className="edit_button"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      this.handleMEPOpen(list.pid);
                                    }}
                                    onKeyUp={() => {
                                      this.handleMEPOpen(list.pid);
                                    }}
                                  >
                                    {t('system.button.edit')}
                                  </a>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    );
                  })
                  : null}
                {error && <div className="error_log">{error}</div>}
                {isNextLoading && <Loader active={isNextLoading} size="medium">{t('list.title.loading')}</Loader>}
              </div>
            ) : (
              <div>
                <Segment>
                  <Dimmer active inverted>
                    <Loader size="large">{t('list.title.loading')}</Loader>
                  </Dimmer>
                </Segment>
              </div>
            )
          }
        </div>
        <ChangeStatusProject
          isOpenMCS={this.state.isOpenMCS}
          closeModal={this.handleMCSClose}
          rowData={this.state.selectedList}
          completeCallback={this.handleCompleteCallback}
          translate={t}
        />
        <DeleteProjectModal
          isOpenMDP={this.state.isOpenMDP}
          closeModal={this.handleMDPClose}
          data={checkValue}
          location={pathname}
          completeCallback={this.handleDeleteCallback}
          translate={t}
        />
        <NewProjectModal
          isOpenMCP={this.state.isOpenMCP}
          closeModal={this.handleMCPClose}
          completeCallback={this.handleNewProjectCallback}
          translate={t}
        />
        <EditProjectModal
          isOpenMEP={this.state.isOpenMEP}
          projectId={this.state.selectedProjectId}
          closeModal={this.handleMEPClose}
          completeCallback={this.handleEditProjectCallback}
          handleDeleteCallback={this.handleDeleteCallback}
          location={pathname}
          translate={t}
        />
        <Modal open={this.state.isOpen} onClose={this.closeErrorModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{t('modal.title.attention')}</h2>
                <p className="text">{t('modal.message.select_one_project')}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeErrorModal}
                    onKeyUp={this.closeErrorModal}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(ProjectSetting))));
